/* istanbul ignore file */
import { combineReducers } from 'redux'
import user from './user'
import rates from './rates'
import rentalCarContract from './rentalCarContract'
import driver from './driver'
import token from './token'
import extras from './extras'
import error from './error'
import booking from './booking'

const rootReducer = () => combineReducers({
    rates,
    rentalCarContract,
    user,
    driver,
    token,
    error,
    extras,
    booking,
})

export default rootReducer
